/* global axios */

import ApiClient from './ApiClient';

class RealEstateCommissionInstallmentsAPI extends ApiClient {
  constructor() {
    super('real_estate_commission_installments', { accountScoped: true });
  }

  catalog() {
    return axios.get(`${this.url}/catalog`);
  }

  updateSheet(id, sheet) {
    return axios.patch(`${this.url}/${id}`, {
      commission_installment: { sheet },
    });
  }

  sendSheet(id) {
    return axios.post(`${this.url}/${id}/send_sheet`);
  }

  reviseSheet(id) {
    return axios.post(`${this.url}/${id}/revise_sheet`);
  }

  download(id) {
    return axios.get(`${this.url}/${id}/download`, { responseType: 'blob' });
  }

  downloadMeiReceipt(id) {
    return axios.post(`${this.url}/${id}/download_mei_receipt`, null, {
      responseType: 'blob',
    });
  }

  downloadArtifact(installmentId, artifactId) {
    return axios.get(
      `${this.url}/${installmentId}/sheets/${artifactId}/download`,
      { responseType: 'blob' }
    );
  }
}

export default new RealEstateCommissionInstallmentsAPI();
